export default __webpack_public_path__ + "static/media/private_lock.4685d1fb.svg";